"use client";
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { setGlobalAuthContext } from "@/utils/errorHandler";

/**
 * Hook that automatically syncs auth context with error handler
 * Use this hook in your root layout or main component
 */
export const useErrorHandler = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      setGlobalAuthContext({
        userId: user.sub,
        roles: user.roles
      });
    } else {
      setGlobalAuthContext(null);
    }
  }, [user]);
};